import { useEffect, useState } from 'react';
import { useInternals } from '../context/internalContext';

// Baixa um arquivo pela rota binary (com token) e devolve uma URL local (blob:) pra usar em
// <img>/<video>. A URL é revogada quando o componente desmonta ou o registro/campo muda.
const useBinaryUrl = ({ resource, id, field } = {}) => {
  const { getBinaryFile } = useInternals();
  const [url, setUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setUrl('');
    setHasError(false);

    if (!resource || !id) {
      setIsLoading(false);
      return undefined;
    }

    const controller = new AbortController();
    let objectUrl = '';
    setIsLoading(true);

    getBinaryFile(resource, id, field, { signal: controller.signal })
      .then((blob) => {
        if (controller.signal.aborted) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      })
      .catch((error) => {
        if (controller.signal.aborted) return;
        if (error?.response?.status !== 404) {
          console.error('Erro ao carregar arquivo', error);
        }
        setHasError(true);
      })
      .finally(() => {
        if (!controller.signal.aborted) setIsLoading(false);
      });

    return () => {
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [resource, id, field, getBinaryFile]);

  return { url, isLoading, hasError };
};

export default useBinaryUrl;
